import React, {Fragment} from 'react';

import {Stack, Typography} from '@mui/material';
import {StyledGrid} from 'presentation/components/Grid';
import {QueryParamsForTaggingEnum} from 'presentation/constants';

import {AppointmentBookingEnum, OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';
import {Snackbar} from 'presentation/components';
import {InstabilityError} from 'presentation/components/Location/InstabilityError';
import {Instructions} from 'presentation/components/Location/Instructions';
import {LoadingLocation} from 'presentation/components/Location/LoadingLocation';
import {LocationOptionCard} from 'presentation/components/Location/LocationOptionCard';
import {translations} from 'presentation/translations-new';
import {getButtonStyleByPermission} from 'presentation/utils/getButtonStyleByPermission';

import {useLocation} from './hooks/useLocation';
import {LocationProps} from './types';

const {title, geolocationCard, manualSelectionCard, autoLocationPermissionDenied} =
	translations['pt-br'].privateFlow.bookingFlow.location;

export function Location({flowType}: Readonly<LocationProps>) {
	const {
		isLaptop,
		isGeolocationEnabled,
		handleGetPosition,
		permission,
		setSearchParams,
		handleNavToStateSelection,
		openInstructions,
		handleOpenInstructions,
		handleCloseInstructions,
		openGetPositionLoading,
		openInstabilityError,
		positionUnavailableOrTimeout,
		geolocationOrPermissionIsNotSupported,
		isUnprocessableError,
		handleCloseInstabilityError,
		handleRetryGetCityLocationAndSpecialties,
		handleGoHome,
		showPermissionDeniedSnackbar,
		handleClosePermissionDeniedSnackbar,
	} = useLocation(flowType);

	return (
		<Fragment>
			<Stack alignItems="center">
				<Stack width={isLaptop ? '100%' : 618} gap={2}>
					<Typography variant="subtitle2" color="text.secondary">
						{title}
					</Typography>
					<StyledGrid.Root>
						{isGeolocationEnabled ? (
							<StyledGrid.Item sm={12} md={6} lg={6}>
								<LocationOptionCard
									dataTagId={AppointmentBookingEnum.CLICK_PROXIMO_A_MIM}
									label={geolocationCard}
									onClick={() => {
										handleGetPosition({state: permission});
										setSearchParams(prev => {
											prev.set(QueryParamsForTaggingEnum.GEOLOCATION, 'true');
											return prev;
										});
									}}
									{...getButtonStyleByPermission({state: permission})}
								/>
							</StyledGrid.Item>
						) : null}
						<StyledGrid.Item sm={12} md={6} lg={6}>
							<LocationOptionCard
								dataTagId={AppointmentBookingEnum.CLICK_ESCOLHER_LOCAL}
								iconName={'my-location-filled'}
								label={manualSelectionCard}
								onClick={() => handleNavToStateSelection(false)}
							/>
						</StyledGrid.Item>
					</StyledGrid.Root>
				</Stack>
			</Stack>
			<Instructions
				closeButtonDataTagId={`${OdontoBookingTaggingEnum.CLICK_SELECIONAR_MANUALMENTE_LOCALIZACAO_DESATIVADA}${flowType}`}
				open={openInstructions}
				onOpen={handleOpenInstructions}
				onClose={handleCloseInstructions}
				onManualSelection={() => handleNavToStateSelection(false)}
			/>
			<LoadingLocation open={openGetPositionLoading} />
			<InstabilityError
				open={openInstabilityError}
				positionUnavailableOrTimeout={positionUnavailableOrTimeout}
				geolocationOrPermissionIsNotSupported={geolocationOrPermissionIsNotSupported}
				isUnprocessableError={isUnprocessableError}
				onClose={handleCloseInstabilityError}
				onRetry={handleRetryGetCityLocationAndSpecialties}
				onGoHome={handleGoHome}
				onManualSelection={() => handleNavToStateSelection(false)}
			/>
			<Snackbar
				onClose={handleClosePermissionDeniedSnackbar}
				message={autoLocationPermissionDenied}
				open={showPermissionDeniedSnackbar}
			/>
		</Fragment>
	);
}
